import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

import { Controller } from "react-hook-form";
import {IDaAutocompleteFieldProps} from "./types";

export const DaAutocompleteField: React.FC<IDaAutocompleteFieldProps<any>> = (
    {
        control,
        name,
        label,
        options = [],
        defaultValue = "",
        readOnly = false,
        required = false,
        size = "medium",
        variant = "standard",
        onInputChange = undefined,
        noOptionsText = "No options available",
        errors
    } : IDaAutocompleteFieldProps<any>

) => {

  return (
      <Controller
          name={name}
          control={control}
          render={({ field: { onChange, ...props } }) =>
              <Autocomplete
                  {...props}
                  size={size}
                  fullWidth
                  options={options}
                  // value={value}
                  getOptionLabel={(option) => (
                      option.label ??
                      options.find(({ value }) => value === option)?.label ??
                      "")
                  }
                  // getOptionLabel={(option) =>
                  //     option?.label ??
                  //     options.find(({ value }) => value === option)?.label ??
                  //     ""
                  // }
                  // Bubble-up change to React Hook Form
                  // onChange={(e, data) => onChange(data)}
                  onChange={(e, data) => {
                      // let newValue = data && data.value ? data.value : data;
                      let newValue = data?.value ?? data ?? "";
                      onChange(newValue);
                  }}
                  onInputChange={onInputChange}
                  isOptionEqualToValue={(option, value) =>
                      value === undefined || value === "" || option.value === value || option.value === value.value
                  }
                  noOptionsText={noOptionsText}
                  renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.value}>
                          {/*{option.label} ({option.code}) +{option.phone}*/}
                          {option.label}
                      </Box>
                  )}
                  renderInput={(params) =>
                      <TextField {...params}
                          label={required ? `${label} *` : label}
                          variant={variant}
                          error={!!errors[name]}
                          helperText={errors[name]?.message ?? ''}
                      />
                  }
                  {...readOnly ? {
                      readOnly: true,
                      disabled: true,
                      disabledItemsFocusable: true} : {}
                  }
              />
          }
        />
  );
};